<mat-toolbar color="primary">
  Cassette Images
</mat-toolbar>

<div class="table-container">
  <table mat-table [dataSource]="imageResults" data-testid="ic-imagesdialog-table" class="image-table" matSort>

    <!-- Image Set Column -->
    <ng-container matColumnDef="imageSetNumber">
      <th mat-header-cell *matHeaderCellDef> Image Set </th>
      <td mat-cell *matCellDef="let row"> {{ row.imageSetNumber }} </td>
    </ng-container>

    <!-- Test Result Id Column -->
    <ng-container matColumnDef="testResultId">
      <th mat-header-cell *matHeaderCellDef> Test Result ID </th>
      <td mat-cell *matCellDef="let row"> {{ row.testResultId }} </td>
    </ng-container>

    <!-- Cassette Column -->
    <ng-container matColumnDef="cassetteNumber">
      <th mat-header-cell *matHeaderCellDef> Cassette </th>
      <td mat-cell *matCellDef="let row"> {{ row.cassetteNumber }} </td>
    </ng-container>

    <!-- Iteration Column -->
    <ng-container matColumnDef="iterationOrder">
      <th mat-header-cell *matHeaderCellDef> Iteration </th>
      <td mat-cell *matCellDef="let row"> {{ row.iterationOrder }} </td>
    </ng-container>

    <!-- Delay Column -->
    <ng-container matColumnDef="delay">
      <th mat-header-cell *matHeaderCellDef> Delay </th>
      <td mat-cell *matCellDef="let row"> {{ row.delay }} ms </td>
    </ng-container>

    <!-- Dark Image Column -->
    <ng-container matColumnDef="dark">
      <th mat-header-cell *matHeaderCellDef> Dark </th>
      <td mat-cell *matCellDef="let row">
        <img *ngIf="row.dark" [src]="row.dark" alt="Dark image" />
      </td>
    </ng-container>

    <!-- Light Image Column -->
    <ng-container matColumnDef="light">
      <th mat-header-cell *matHeaderCellDef> Light </th>
      <td mat-cell *matCellDef="let row">
        <img *ngIf="row.light" [src]="row.light" alt="Light image" />
      </td>
    </ng-container>

    <!-- CC Image Column -->
    <ng-container matColumnDef="cc">
      <th mat-header-cell *matHeaderCellDef> CC </th>
      <td mat-cell *matCellDef="let row">
        <img *ngIf="row.cc" [src]="row.cc" alt="CC image" />
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['imageSetNumber', 'testResultId', 'cassetteNumber', 'iterationOrder', 'delay', 'dark', 'light', 'cc']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['imageSetNumber', 'testResultId', 'cassetteNumber', 'iterationOrder', 'delay', 'dark', 'light', 'cc'];"></tr>
  </table>
</div>

<div class="actions">
  <button mat-raised-button color="accent" data-testid="ic-imagesdialog-close-button" (click)="close()">Close</button>
</div>
